import { LOGO_URL, LOGO_SYMBOL_URL } from 'app/constants';
import template from './logo.html';
import './logo.scss';

export const logoComponent = {
    template,
    bindings: {
        clickable: '<',
        logoType: '@'
    },
    controller: class LogoComponent {
        constructor($window) {
            'ngInject';

            angular.extend(this, {
                $window
            });
        }

        $onInit() {
            this.logoUrl = this.logoType === 'full' ? LOGO_URL : LOGO_SYMBOL_URL;
        }

        onClick() {
            if (!this.clickable) return;
            this.$window.open('https://volusion.com', '_self');
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/components/logo/logo.component.js